(function($) {
  'use strict';

  var forms = {
    dom: function() {
      this.$checkbox      = $('input[data-checkbox][type="checkbox"]');
      this.$infieldLabels = $('[data-infield-label]');
      this.$datePicker    = $('[data-js-hook="pickadate"]');

      this.$contactForm   = $('#contact-form');
    },

    checkbox: function() {
      var $checkboxes = $('input[data-checkbox][type="checkbox"]');

      if ($checkboxes.length) {
        $checkboxes.each(function(){
          var $fakeCheckbox = $('[data-checkbox="' + $(this).data('checkbox') + '"]:not(input)');

          $(this).on('change', function(){
            if ($(this).prop('checked')) {
              $fakeCheckbox.addClass('form__checkbox-fake--checked');
            } else {
              $fakeCheckbox.removeClass('form__checkbox-fake--checked');
            }
          });
        });
      }
    },

    infieldLabels: function() {
      this.$infieldLabels.each(function() {
        var self = $(this);
        var target = $(this).attr('for');
        var input = $('#'+target);
        input.on('focus', function(){
          if (!$(this).val()) {
            self.addClass('focus');
          }
        });
        input.on('keyup input', function() {
          if ($(this).val()) {
            self.removeClass('focus');
            self.addClass('active');
          }
          else {
            self.removeClass('active');
            self.addClass('focus');
          }
        });
        input.on('blur', function() {
          if (!$(this).val()) {
            self.removeClass('focus');
          }
        });
      });
    },

    pickadate: function() {
      this.$datePicker.on('mousedown',function(e){
        e.preventDefault();
      }).pickadate({
        container: 'body',
        format: 'mmm d, yyyy',
        disable: [
          {from: [0, 0, 0], to: new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24)}
        ],
        onRender: function() {
          forms.$datePicker.removeAttr('aria-expanded');
          $($(this)[0].$root[0]).find('[aria-activedescendant]').removeAttr('aria-activedescendant');
        },
        onSet: function(thingSet) {
          var label = $(this)[0].$node.attr('id');
          label = $('[for='+label+']');
          if (thingSet.select !== undefined) {
            label.addClass('active');
          }
          else {
            label.removeClass('active');
          }
        }
      });
    },

    replaceFormConfirmMessageVariables: function($form, $confirmation) {
      if ($form.length) {
        var formData = serializedArrayToObject($form.serializeArray());

        if ($confirmation.length) {
          $confirmation.children().each(function(){
            var $child = $(this);
            var text = $child.text();
            var varReplace;

            if (!$child.data('original-content')) {
              $child.data('original-content', text);
            }

            text = $child.data('original-content');

            if (varReplace = text.match(/\{(.*?)\}/gi)) {
              for (i = 0; i < varReplace.length; i++) {
                var replace = varReplace[i];
                var varName = replace.replace(/^\{|\}$/gi, '').replace(/(^|\-|\_)([a-z])/g, function (g) { return g.toUpperCase(); }).replace(/\-|\_/g, '');

                if (typeof formData[varName] != 'undefined') {
                  text = text.replace(replace, formData[varName]);
                }
              }
            }

            $child.text(text);
          });
        }
      }
    },

    forms: function() {
      var self = this;
      var requiredFields = [];
      var $requiredFields = this.$contactForm.find('[data-field-required]');

      if ($requiredFields.length) {
        $requiredFields.each(function(){
          requiredFields.push($(this).find('input,textarea,select').attr('name'));
        });
      }

      // -- Validate the form
      this.$contactForm.formulate({
        require: requiredFields.join(','),
        errorClass: 'error',
        errorParent: true,
        showOnSubmit: '#contact-confirm',
        inlineMsg: true,
        inlineMsgClass: 'form__inline-error',
        fireOnSubmit: function() {
          $(':submit', self.$contactForm).addClass('btn-submitting');
          $('.form__loading', self.$contactForm).fadeIn(200);
        },
        fireOnSuccess: function() {
          Jonahlytics.event.formSubmit('contact-form');
          $('.form__loading', self.$contactForm).fadeOut(200);
          cmg_google_conversion($('#contact_us_conversion').val(), $('#contact_us_conversion_id').val(), $('#contact_us_conversion_html').val());
          self.replaceFormConfirmMessageVariables(self.$contactForm, $('#contact-confirm'));
          $(':submit', self.$contactForm).removeClass('btn-submitting');
        },
        fireOnError: function(){
          $('.form__loading', self.$contactForm).fadeOut(200);
          $(':submit', self.$contactForm).removeClass('btn-submitting');
        }
      });
    },

    ready: function() {
      this.dom();
      this.infieldLabels();
      this.pickadate();
      this.checkbox();
      this.forms();
    }
  };

  $(function() { forms.ready(); });

})(jQuery);
